import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { animated } from 'react-spring';

import Modal from 'js/components/core/Modal';
import ReceivingAccountStore from 'js/stores/pages/MyAccountPageState/ReceivingAccount';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import BankAccountDisplay from 'js/components/core/BankAccountDisplay';
import Container from './Container';
import AccountVerification from './AccountVerification';
import CannotSubmitVerification from './CannotSubmitVerification';

import Button from '../Button';
import TitleIcon from '../TitleIcon';
import Notice from '../Notice';
import SectionTitle from '../SectionTitle';

import EditForm from './EditForm';
import VerifyForm from './VerifyForm';
import ChoicesForm from './ChoicesForm';
import CreditCardDisplay from 'js/components/core/CreditCardDisplay';
import AppUser from 'js/stores/AppUser';
import NewBankAccount from 'js/components-v2/pages/NewBankAccount';
import UserCountry from 'js/services/UserCountry';
import userCountry from 'js/services/UserCountry';

@observer
export default class ReceivingAccount extends Component {
  state = ReceivingAccountStore.create({
    bankAccount: this.props.state ? this.props.state.bankAccount : {},
    debitCard: this.props.state ? this.props.state.debitCard : {},
  });

  render() {
    const state = this.state;
    const { plaidIsStarted, plaidIsUpdating, savingPlaidItem, plaidError } = state;
    const {
      is_verified,
      can_submit_verification,
      verification_denial_reason,
      verification_wait_reason,
      verification_failure_message,
      needs_update,
      id,
      bank_verification_flow,
    } = state.bankAccount;

    const showDisplayBankAccount = id;
    const showDisplayDebitAccount = state.debitCard.id;

    return (
      <>
        <animated.div style={this.props.animation}>
          <Container>
            <SectionTitle>
              <TitleIcon name="university"/>
              <div>Receiving account</div>
            </SectionTitle>
            <Notice>If you sell something with us, we'll pay you through this account.</Notice>
            {
              (showDisplayBankAccount || showDisplayDebitAccount)
                ? (<>
                  {showDisplayBankAccount ? (
                    <>
                      <BankAccountDisplay
                        bankAccount={state.bankAccount}
                        onEdit={state.showModal}
                        isBusy={plaidIsStarted || savingPlaidItem}
                      />

                      {is_verified || bank_verification_flow !== 'system' || userCountry() === 'NG' ? null : can_submit_verification ? (
                        <AccountVerification
                          state={state}
                          onVerify={state.onVerify}
                          isBusy={plaidIsUpdating}
                          verification_wait_reason={verification_wait_reason}
                          verification_failure_message={verification_failure_message}
                          needs_update={needs_update}
                        />
                      ) : (
                        <CannotSubmitVerification
                          verification_denial_reason={verification_denial_reason}
                          verification_failure_message={verification_failure_message}
                        />
                      )}
                      <ErrorDisplay>{plaidError}</ErrorDisplay>
                      <br/>
                    </>
                  ) : (<></>)}
                  {
                    showDisplayDebitAccount
                    ? (<><CreditCardDisplay creditCard={state.debitCard} onEdit={state.showChoicesModal}/></>)
                    : (<></>)
                  }
                </>)
                : (
                  <>
                    <div>You don't have a receiving account set up yet.</div>
                  </>
                )
            }
            <Button onClick={state.showChoicesModal} isLoading={plaidIsStarted || savingPlaidItem}>
              {plaidIsStarted
                ? 'Please wait...'
                : savingPlaidItem
                  ? 'Registering account...'
                  : (showDisplayBankAccount || showDisplayDebitAccount) ? 'Change receiving account' : 'Add receiving account'}
            </Button>
          </Container>
        </animated.div>


        <Modal showModal={state.modalIsVisible} onCancel={state.closeModals} withCloseButton>
          <EditForm state={state}/>
        </Modal>

        <Modal showModal={state.verifyModalIsVisible} onCancel={state.closeModals} withCloseButton>
          <VerifyForm state={state}/>
        </Modal>

        <Modal showModal={state.choicesModalIsVisible} onCancel={state.closeModals} withCloseButton>
          {UserCountry() === 'NG' ? (
            <NewBankAccount page={state} />
          ) : (
            <ChoicesForm state={state}/>
          )}
        </Modal>

        <Modal showModal={state.verifyChoicesModalIsVisible} onCancel={state.closeModals} withCloseButton>
          <VerifyForm state={state}/>
        </Modal>
      </>
    );
  }
}
